import { FormattedMessage } from 'react-intl';
import { Link, useLocation, useSearchParams } from 'react-router';

import { createDebugConfig, trackCustomEvent } from '@/configuration/setup/googleAnalytics';
import { USER_MANUAL_TAB_PARAM } from '@/features/userManual/utils';
import { useWhatsNewStore } from '@/stores/whatsNewStore';

export interface UserManualNavItemProps {
    keyPage: string;
    prefix: string;
    anchor?: string;
    section?: string;
}

export const UserManualNavItem = ({ keyPage, prefix, anchor, section }: UserManualNavItemProps) => {
    const { showNotification } = useWhatsNewStore();
    const { pathname, search, hash } = useLocation();

    const [searchParams] = useSearchParams();
    searchParams.set(USER_MANUAL_TAB_PARAM, keyPage);

    const triggerGAEvent = () => {
        if (!anchor) {
            const flowName = section ? `user_manual_${section}` : 'user_manual';

            trackCustomEvent(
                `open_${keyPage}`,
                {
                    trigger: 'click',
                    flow_name: flowName,
                    element_name: 'change_modal_tab',
                },
                createDebugConfig()
            );
        }
    };

    const currentAnchor = hash?.split('#').pop();
    const isActive = search.endsWith(keyPage) && (!anchor || currentAnchor === anchor);
    const shouldShowWhatsNewBadge = showNotification && keyPage === 'whatsNew';

    const idKey = anchor || keyPage;

    return (
        <Link
            to={{ pathname, search: searchParams.toString(), hash: anchor ? `#${anchor}` : undefined }}
            className={`border-left-only ${isActive && 'active'}`}
            data-key={idKey}
            onClick={triggerGAEvent}
        >
            <div className='display-flex align-items-center'>
                <FormattedMessage id={`${prefix}.${idKey}.title`} />
                {shouldShowWhatsNewBadge && <span className='badge badge-primary margin-left-5' />}
            </div>
        </Link>
    );
};
